import { Dropdown, Menu, Modal } from 'antd';
import { Form, Formik } from 'formik';
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { ActionMenuIcon, EditAppointmentIcon, PlusIcon } from 'src/icons';
import { getFronteggPlans } from 'src/modules/SuperAdmin/store/actions/organization.action';
import {
  addNewPreBuiltTemplatesMappingAction,
  getPreBuiltTemplatesMappingAction,
} from '../../../../store/actions/prebuilttemplates.action';
import { SingleSelect } from '../../../baseComponents';
import { SuperAdminTable } from '../../../baseComponents/Table';
import EditTemplatesPage from './EditTemplates.page';

const PreBuiltTemplatesPage = () => {
  const dispatch = useDispatch();
  const [tableData, setTableData] = useState([]);
  const [tableLoader, setTableLoader] = useState(false);
  const [editModalOpen, setEditModalOpen] = useState(false);
  const [selectedPlan, setSelectedPlan] = useState(null);
  const [selectedTemplates, setSelectedTemplates] = useState([]);
  const [addNewPlanModalOpen, setAddNewPlanModalOpen] = useState(false);
  const [plansToAdd, setPlansToAdd] = useState([]);
  const [selectedPlansToAdd, setSelectedPlansToAdd] = useState([]);

  const { preBuiltTemplatesMapping, preBuiltTemplatesLoading } = useSelector(
    (state) => state.preBuiltTemplatesState
  );

  const { fronteggPlans } = useSelector((state) => state.organizationState);

  useEffect(() => {
    dispatch(getPreBuiltTemplatesMappingAction());
    dispatch(getFronteggPlans());
  }, [dispatch]);

  useEffect(() => {
    if (fronteggPlans && preBuiltTemplatesMapping) {
      setPlansToAdd(
        fronteggPlans.filter(
          (plan) =>
            !preBuiltTemplatesMapping.some(
              (existingPlan) => existingPlan.plan_object.plan_id === plan.id
            )
        )
      );
    }
  }, [fronteggPlans, preBuiltTemplatesMapping]);

  useEffect(() => {
    if (preBuiltTemplatesMapping) {
      setTableData(preBuiltTemplatesMapping);
    }
  }, [preBuiltTemplatesMapping]);

  useEffect(() => {
    setTableLoader(preBuiltTemplatesLoading);
  }, [preBuiltTemplatesLoading]);

  const handleFormSubmit = (values) => {
    console.log(values);
  };

  const handleEditOpen = (record) => {
    setSelectedPlan(record?.plan_object);
    setSelectedTemplates(record?.templates);
    setEditModalOpen(true);
  };

  const menu_options = (record) => {
    return (
      <Menu
        onClick={({ key }) => {
          if (key === 'editTemplates') {
            handleEditOpen(record);
          }
        }}
      >
        <Menu.Item key="editTemplates">
          <div className="dropdown-text flex items-center space-x-2">
            <EditAppointmentIcon /> <span>Edit templates</span>
          </div>
        </Menu.Item>
      </Menu>
    );
  };

  const columns = [
    {
      title: 'Plan name',
      render: (text, record) => {
        return <div>{record?.plan_object?.plan_name}</div>;
      },
    },
    {
      title: 'Pre-built templates',
      dataIndex: 'templates',
      width: '60%',
      render: (text, record) => {
        return (
          <div className="flex flex-wrap gap-2">
            {record?.templates?.map((template, index) => {
              return (
                <div
                  key={index}
                  className="flex items-center px-3 py-1 gap-1 mt-2 w-fit rounded-3xl"
                  style={{ border: `1px solid #00D090` }}
                >
                  {template.template_name}
                </div>
              );
            })}
          </div>
        );
      },
    },
    {
      title: '',
      key: 'actions',
      dataIndex: 'actions',
      render: (text, record) => {
        return (
          <Dropdown className="" overlay={menu_options(record)}>
            <a className="" onClick={(e) => e.preventDefault()}>
              <ActionMenuIcon />
            </a>
          </Dropdown>
        );
      },
    },
  ];

  return (
    <Formik initialValues={{}} onSubmit={handleFormSubmit}>
      {({ handleSubmit }) => (
        <Form onSubmit={handleSubmit}>
          <div className="flex flex-row sm:justify-between gap-4 lg:justify-between items-center">
            <div className="flex flex-col justify-center"></div>
            <div className="flex justify-end items-end gap-2">
              {plansToAdd.length > 0 && (
                <div>
                  <button
                    type="button"
                    className="bg-[#00D090] hover:bg-[#059669] flex items-center justify-center text-white font-normal p-2 py-2 px-4 rounded-xl focus:outline-none focus:shadow-outline"
                    onClick={() => {
                      setAddNewPlanModalOpen(true);
                    }}
                  >
                    <PlusIcon
                      className={`mr-1`}
                      width="14"
                      height="14"
                      viewBox="0 0 16 16"
                    />{' '}
                    Add new plan
                  </button>
                </div>
              )}
            </div>
          </div>
          <div className="super-admin-table">
            <div className="mt-5 ant-table rounded-xl shadow-xl">
              <SuperAdminTable
                className={`appointment-page-table`}
                columns={columns}
                data={tableData}
                loading={tableLoader}
              />
            </div>
          </div>
          <EditTemplatesPage
            isOpen={editModalOpen}
            setIsOpen={setEditModalOpen}
            selectedPlan={selectedPlan}
            selectedTemplates={selectedTemplates}
          />
          <Modal
            title="Add new plan"
            open={addNewPlanModalOpen}
            width={600}
            centered={true}
            closeIcon={false}
            onCancel={() => {
              setAddNewPlanModalOpen(false);
              setSelectedPlansToAdd([]);
            }}
            footer={[
              <div className="flex justify-end gap-2" key="actions">
                <button
                  key="back"
                  className="bg-[#A9A9A9] hover:bg-[#899499] text-white font-normal p-1 py-1 px-2 rounded-md focus:outline-none focus:shadow-outline"
                  onClick={() => {
                    setAddNewPlanModalOpen(false);
                    setSelectedPlansToAdd([]);
                  }}
                >
                  Cancel
                </button>
                <button
                  key="submit"
                  disabled={selectedPlansToAdd.length === 0}
                  className="bg-[#00D090] hover:bg-[#059669] text-white font-normal p-1 py-1 px-2 rounded-md focus:outline-none focus:shadow-outline"
                  onClick={() => {
                    dispatch(
                      addNewPreBuiltTemplatesMappingAction(
                        selectedPlansToAdd,
                        setAddNewPlanModalOpen,
                        setSelectedPlansToAdd
                      )
                    );
                  }}
                >
                  Add
                </button>
              </div>,
            ]}
          >
            <div className="flex flex-col h-full p-4">
              <SingleSelect
                options={plansToAdd.map((plan) => ({
                  label: plan.name,
                  value: plan.id,
                }))}
                placeholder="Select plan"
                value={selectedPlansToAdd}
                onChange={(value) => {
                  setSelectedPlansToAdd(value);
                }}
                dropdownMode="multiple"
              />
            </div>
          </Modal>
        </Form>
      )}
    </Formik>
  );
};

export default PreBuiltTemplatesPage;
